/**
 * popdot-visual-engine.js
 * Motor visual compartilhado — Pop Dot.
 *
 * Funcoes puras de resolucao visual. Sem efeitos colaterais de DOM.
 * Consumido por: product-visualizer.js (e futuro wall-simulator.js)
 *
 * Expoe: window.PopdotVisualEngine
 *
 * Carregamento: deve ser incluido ANTES de product-visualizer.js
 * (com defer — ordem de declaracao e respeitada).
 */

(function () {
  'use strict';

  // ==========================================================================
  // UTILITARIOS
  // ==========================================================================

  function normalize(str) {
    return (str || '').toLowerCase().trim();
  }

  function matchesAny(value, list) {
    var v = normalize(value);
    return (list || []).some(function (n) {
      return v === normalize(n) || v.includes(normalize(n));
    });
  }

  // ==========================================================================
  // RESOLUCAO DE MATERIAL
  // ==========================================================================

  function resolveMaterial(optionValue, config) {
    var materials = (config || {}).materials || {};
    if (matchesAny(optionValue, materials.paper))  return 'paper';
    if (matchesAny(optionValue, materials.canvas)) return 'canvas';
    return null;
  }

  // ==========================================================================
  // RESOLUCAO DE MOLDURA
  // ==========================================================================

  function resolveFrame(optionValue, config) {
    var frames = (config || {}).frames || {};
    for (var key in frames) {
      if (Object.prototype.hasOwnProperty.call(frames, key)) {
        if (matchesAny(optionValue, frames[key])) return key;
      }
    }
    return null;
  }

  // ==========================================================================
  // RESOLUCAO DE ORIENTACAO
  // ==========================================================================

  /**
   * Resolve a orientacao da obra.
   * Fonte primaria: hint (string do metafield custom.orientacao).
   * Fonte secundaria: aspect ratio do elemento <img>.
   */
  function resolveOrientation(imgEl, hint, config) {
    var orientCfg = ((config || {}).orientation) || {};
    var threshold = orientCfg.squareThreshold || 0.1;
    var values    = orientCfg.values || {
      vertical:   'vertical',
      horizontal: 'horizontal',
      square:     'square',
    };

    // Fonte primaria: metafield hint
    var h = normalize(hint || '');
    if (h === 'vertical')   return values.vertical;
    if (h === 'horizontal') return values.horizontal;
    if (h === 'square' || h === 'quadrado') return values.square;

    // Fonte secundaria: aspect ratio
    if (!imgEl) return null;

    var w  = imgEl.naturalWidth;
    var ht = imgEl.naturalHeight;

    if (!w || !ht) return null;

    var ratio = w / ht;

    if (Math.abs(ratio - 1) < threshold) return values.square;
    if (ratio > 1) return values.horizontal;
    return values.vertical;
  }

  // ==========================================================================
  // RESOLUCAO DO OVERLAY
  // ==========================================================================

  /**
   * Resolve o nome do arquivo PNG de overlay.
   * Regra: frame === 'none' -> null (sem overlay, sem arquivo).
   */
  function resolveOverlay(orientation, material, frame, config) {
    if (!frame || frame === 'none') return null;
    if (!orientation || !material)  return null;

    var pattern = ((config || {}).overlay || {}).pattern
      || 'overlay-{material}-{orientation}-{frame}.png';

    return pattern
      .replace('{material}',    material)
      .replace('{orientation}', orientation)
      .replace('{frame}',       frame);
  }

  // ==========================================================================
  // ARTWORK — IMAGEM DA OBRA
  // ==========================================================================

  function getArtworkImage(images) {
    if (!images || images.length === 0) return null;
    var img = images[images.length - 1];
    return {
      src:    img.src    || img.url || '',
      alt:    img.alt    || '',
      width:  img.width  || 0,
      height: img.height || 0,
    };
  }

  // ==========================================================================
  // VARIANTE — ENCONTRAR VARIANTE POR OPCOES
  // ==========================================================================

  function findMatchingVariant(variants, options, config) {
    if (!variants || variants.length === 0) return null;

    var targetMaterial = options.material
      ? resolveMaterial(options.material, config)
      : null;

    var targetFrame = options.frame
      ? resolveFrame(options.frame, config)
      : null;

    var targetSize = normalize(options.size || '');

    return variants.find(function (variant) {
      var opts = variant.options || [];

      if (targetSize && opts[0] && normalize(opts[0]) !== targetSize) {
        return false;
      }

      if (targetMaterial) {
        var varMaterial = resolveMaterial(opts[1] || '', config);
        if (varMaterial !== targetMaterial) return false;
      }

      if (targetFrame) {
        var varFrame = resolveFrame(opts[2] || '', config);
        if (varFrame !== targetFrame) return false;
      }

      return true;
    }) || null;
  }

  // ==========================================================================
  // EXPORT
  // ==========================================================================

  window.PopdotVisualEngine = {
    normalize:            normalize,
    matchesAny:           matchesAny,
    resolveMaterial:      resolveMaterial,
    resolveFrame:         resolveFrame,
    resolveOrientation:   resolveOrientation,
    resolveOverlay:       resolveOverlay,
    getArtworkImage:      getArtworkImage,
    findMatchingVariant:  findMatchingVariant,
  };

})();